














































































import { Vue, Component, Watch } from 'vue-property-decorator';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import moment from 'moment';

import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';

import { ParamApi, FilterApi } from './models/ReportesBajasTransito.model';

import { fetchMS } from './fetchMS';

@Component({ components: { DatePicker } })
export default class ReportesBajasTransitoFilters extends Vue {
  readonly loadingService: LoadingService = new LoadingService();
  readonly $snotify: Snotify = null;

  now: string = moment().format('YYYY-MM-DD');
  activateChangeFn: boolean = false;

  paramApi: ParamApi = {
    start_date: moment().subtract(1, 'month'),
    end_date: moment(),
  };

  filterApi: FilterApi = {};

  mounted() {
    this.getFilters();
  }

  handleSearchFilter() {
    this.activateChangeFn = true;
    this.handleFilters();
  }

  handleCleanFilters() {
    this.activateChangeFn = false;
    this.paramApi = {};
    this.paramApi.start_date = moment().subtract(1, 'month');
    this.paramApi.end_date = moment();
    const params = { ...this.paramApi };
    this.$emit('filters', params);
  }

  handleFilters() {
    if (this.activateChangeFn) {
      const params = { ...this.paramApi };
      this.$emit('filters', params);
    }
  }

  @Watch('paramApi.start_date')
  startDateChange() {
    if (this.paramApi.start_date > this.paramApi.end_date) {
      this.paramApi.end_date = this.paramApi.start_date;
    }
    this.handleFilters();
  }

  @Watch('paramApi.end_date')
  endDateChange() {
    if (this.paramApi.end_date < this.paramApi.start_date) {
      this.paramApi.start_date = this.paramApi.end_date;
    }
    this.handleFilters();
  }

  async getFilters() {
    try {
      this.loadingService.showLoading(null, 'get');
      const result = await fetchMS({ endpoint: 'get_filters' });
      const { MENSAJE_RESPUESTA, CODIGO_RESPUESTA, FILTER } = result.data;
      const cod: number = Number(CODIGO_RESPUESTA);

      if (cod !== 1) {
        throw new Error(MENSAJE_RESPUESTA);
      }
      this.filterApi = { ...FILTER };
    } catch (error) {
      if (error instanceof Error && error.message !== 'Network Error') {
        this.$snotify.error(error.message, { timeout: 3000 });
        return;
      }
      this.$snotify.error(
        'Ha ocurrido un error inesperado, por favor intente más tarde',
        { timeout: 3000 }
      );
    } finally {
      this.loadingService.hideLoading('get');
    }
  }
}
